import React from "react";
import styles from "../../styles/settings/maintenance.module.css";
import maintenance from "../../assets/images/maintenance.svg";
import { Button } from "@mui/material";

const Maintenance = () => {
  return (
    <>
      <div className={styles.main_container}>
        <div className={styles.image_container}>
          <img src={maintenance} alt="not found" className={styles.image} />
        </div>
        <div className={styles.text_container}>
          <p className={styles.heading}>oops! site is under maintenance</p>
          <p className={styles.subheading}>
            We’re working hard to improve your experience.
          </p>
          <p className={styles.subheading}>Check back soon for updates!</p>

          <Button
            variant="contained"
            className={styles.button}
            // onClick={() => {
            //   window.location.href = "/dashboard";
            // }}
          >
            Turn Back
          </Button>
        </div>
      </div>
    </>
  );
};

export default Maintenance;
